import CheckYourEmailModal from 'components/GlobalModals/CheckYourEmailModal/CheckYourEmailModal';
import { withCheckYourEmailModalProps } from 'viewModel/globalModals/checkYourEmailModal/withCheckYourEmailModalProps';

export default withCheckYourEmailModalProps(CheckYourEmailModal);
